import { csvImportExportService } from "../../services/exportImportFile/csvImportExportService";
import { HTTP_SUCCESS_STATUS_CODES } from "../../../constants/VorgangDetailsConstants";

function getCSVUploadedAndErrorFileSuccess(resp) {
  return {
    type: "GET_CSV_UPLOADED_AND_ERROR_FILE_SUCCESS",
    resp,
  };
}

function getCSVUploadedAndErrorFile() {
  return async (dispatch) => {
    const resp = await csvImportExportService.getCSVUploadedAndErrorFile();
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      dispatch(getCSVUploadedAndErrorFileSuccess(resp));
      return resp;
    }
  };
}

function excelResponseSucess(resp) {
  return { type: "GET_EXCEL_RESPONSE_SUCCESS", resp };
}

function excelResponseFailure(resp) {
  return {
    type: "GET_EXCEL_RESPONSE_ERROR",
    error: resp || "Service Unavailable, please refresh !!!",
  };
}

function getExcelResponse(file) {
  return (dispatch) => {
    return csvImportExportService.getexcelResponse(file).then((resp) => {
      if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
        dispatch(excelResponseSucess(resp));
        dispatch(getCSVUploadedAndErrorFile());
        return resp;
      } else {
        dispatch(excelResponseFailure(resp));
        return resp;
      }
    });
  };
}

function dashboardExcelFileDownload(requestID) {
  return () => {
    return csvImportExportService.dashboardExcelFileDownload(requestID);
  };
}

function excelResponseReset() {
  return {
    type: "GET_EXCEL_RESPONSE_RESET",
  };
}

function getDocumentImportCSVErrorFile(csvUploadId) {
  return async () => {
    const resp = await csvImportExportService.getDocumentImportCSVErrorFile(
      csvUploadId
    );
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      return resp;
    }
  };
}

function closeAndIgnoreCsvDownload(csvUploadId) {
  return async () => {
    const resp = await csvImportExportService.closeAndIgnoreCsvDownload(
      csvUploadId
    );
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      return resp;
    }
  };
}

export const csvImportExportAction = {
  // Added for unit testcases
  excelResponseSucess,
  excelResponseFailure,
  getCSVUploadedAndErrorFileSuccess,

  getExcelResponse,
  excelResponseReset,
  dashboardExcelFileDownload,
  getCSVUploadedAndErrorFile,
  getDocumentImportCSVErrorFile,
  closeAndIgnoreCsvDownload,
};
